import { Box, styled } from '@mui/material';

export const WrapperButtons = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCardMobileList',
})(({ isCardMobileList }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignSelf: !isCardMobileList && 'end',
  gap: '12px',
  order: 4,
}));
